<template>
  <div class="dialogBox" v-draggable v-if="visible">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ title ? title : '信息展示' }}</span>
        <el-button style="float: right; padding: 9px 0" type="text" @click="close"><i class="el-icon-circle-close iconStyle"></i></el-button>
      </div>
      <slot name="body"></slot>
    </el-card>
    <div class="boxFooter">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  components: {

  },
  data() {
    return {

    };
  },
  computed: {

  },
  watch: {

  },
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    rote() {
      this.$emit('rote');
    }
  }
};
</script>

<style scoped lang="scss">
.boxFooter {
  text-align: center;
  background: #fff;
  padding: 10px 0;
}

.iconStyle {
  font-size: 18px;
}

.dialogBox {
  position: fixed;
  top: 5%;
  left: 20%;
  width: 1200px;
  height: auto;

  background-color: #fff;
  border: 1px solid #e2d9d9;
  border-radius: 10px;
  z-index: 9999;
}

.move-dialog-header {
  height: 30px;
  line-height: 30px;
  text-align: right;
  padding-right: 15px;
  border-bottom: 0.5px solid #e2d9d9;
}

// 覆盖层元素增加可穿透点击事件
/deep/.el-dialog__wrapper {
  pointer-events: none;
}

// 弹窗层元素不可穿透点击事件（不影响弹窗层元素的点击事件）
/deep/.el-dialog {
  pointer-events: auto;
}

/deep/.el-card__body {
  overflow: hidden;
  min-height: 620px;
  max-height: 720px;
}
/deep/.el-card__header{
  padding: 5px 20px;
}
</style>
